export default __webpack_public_path__ + "static/media/sauraha.2397f7e8.jpg";